function setSectionHeight() {
  let section = document.querySelector('.drawer_sticky');
  if (!section) {
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--cart-drawer-bottom-content', sectionHeight);
}

setSectionHeight();
setTimeout(setSectionHeight, 3000);
window.addEventListener('resize', setSectionHeight);

// For ajax Cart Drawer
const openCartDrawer = (event) => {
  event.preventDefault();
  var loadAjax = event.currentTarget.dataset.loadAjax;
  window.ajaxDrawer.init(loadAjax, true);
}

document.querySelector("#cart-icon-bubble").addEventListener("click", openCartDrawer.bind(this));

window.ajaxDrawer = {
  init: function (loadAjax, openDrawer = false) {
    ajaxDrawer.openDrawer = openDrawer;
    ajaxDrawer.onLoadAddListeners();
    this.updateProductRecommendations();
    (loadAjax == "true") ? this.getCartData() : false;
  },
  onLoadAddListeners: function () {
    if (ajaxDrawer.openDrawer == true) {
      ajaxDrawer.addDrawerClass();
    }
    ajaxDrawer.closeDrawerEvent();
    ajaxDrawer.removeItemFromCart();
    ajaxDrawer.updateQuantityEvent();
  },
  getCartData: function () {
    if (ajaxDrawer.openDrawer == true) {
      ajaxDrawer.addDrawerClass();
    }
    // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';

    var $this = this;
    fetch('/cart').then(function (response) {
      // The API call was successful!
      return response.text();
    }).then(function (html) {
      document.getElementById('cart-icon-bubble').setAttribute('data-load-ajax', "false");
      // document.querySelector('[loading-for-quickview]').style.display = 'none';
      // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'none';
      // This is the HTML from our response as a text string
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html'),
        htmlData = doc.querySelector('[data-items-wrapper]').innerHTML,
        htmlrecommentedData = doc.querySelector('.cart_drawer_related_content').innerHTML,
        totalQuantity = doc.querySelector('[data-items-wrapper]').dataset.totalitems;
      document.querySelector(".cartBubbleCount").innerText = totalQuantity;

      // console.log("htmlData",htmlData,"htmlrecommentedData",htmlrecommentedData);


      if (document.body.classList.contains('template-cart')) {
        var itemCount = doc.querySelector('#main-cart-items').dataset.itemCount;
        if (itemCount == "0") {
          document.querySelector('.cart_wrapper').classList.add('is-empty');
        }
        document.querySelector('#main-cart-items .js-contents').innerHTML = doc.querySelector('#main-cart-items .js-contents').innerHTML;
        document.querySelector('#main-cart-footer').innerHTML = doc.querySelector('#main-cart-footer').innerHTML;
        new CartItems();
      }

      $this.htmlrecommentedData(htmlrecommentedData);
      $this.addDataInDrawer(htmlData);
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  },
  addDataInDrawer: function (data) {
    document.getElementById("dropdown-cart").querySelector('[data-cart-items]').innerHTML = data;
    this.closeDrawerEvent();
    this.updateQuantityEvent();
    this.removeItemFromCart();
    addGiftProduct.init(document.querySelector('[data-cart-items]'), true);
    // Add this line to ensure recommendations are updated after cart content is updated
    this.updateProductRecommendations();
  },

  htmlrecommentedData: function (data) {
    console.log("data", data);
    document.getElementById("dropdown-cart").querySelector('.cart_drawer_related_content').innerHTML = data;
    setTimeout(() => {
      this.updateProductRecommendations();
    }, 100)
  },
  updateQuantityEvent: function () {
    var $this = this;
    document.querySelectorAll('.quantity-select').forEach(function (dropdown) {
      dropdown.addEventListener('change', function () {
        var variantId = this.dataset.variantid,
          newQuantity = parseInt(this.value);

        var item = {
          id: variantId,
          quantity: newQuantity
        };
        $this.changeQuantity(item);
      });
    });
  },
  updateProductRecommendations: function () {
    const recommendationsElement = document.querySelector('product-recommendations');
    const recommendationsElementMobile = document.querySelector('product-recommendations-mob');
    const relatedContent = document.querySelector(".cart_drawer_related_content");
    const dropdown_cart = document.querySelector("#dropdown-cart");

    // First check if cart is empty based on DOM
    const cartCount = parseInt(document.querySelector(".cartBubbleCount").innerText || "0");

    if (cartCount === 0) {
      // Hide recommendations for empty cart
      if (relatedContent) relatedContent.classList.remove('show_related');
      if (dropdown_cart) dropdown_cart.classList.add('hide_related');
      return;
    }

    const updateRecommendations = (element, target) => {
      if (element && element.dataset.url) {
        const url = element.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const recommendations = doc.querySelector(`#${target}`);

            if (recommendations && recommendations.innerHTML.trim().length) {
              element.replaceWith(recommendations);
              element.classList.add('product-recommendations--loaded');

              // Show recommendations container
              if (relatedContent) relatedContent.classList.add('show_related');
              setSectionHeight();
              if (dropdown_cart) dropdown_cart.classList.remove('hide_related');

              // Initialize quick view functionality
              if (typeof ella !== 'undefined' && ella.initQuickView) {
                ella.initQuickView();
              }

              // Add click listeners to add-to-cart buttons
              recommendations.querySelectorAll(".add-to-cart").forEach((button) => {
                button.addEventListener("click", function (event) {
                  event.preventDefault();
                  add(event);
                });
              });
            } else {
              // No recommendations available
              if (dropdown_cart) dropdown_cart.classList.add('hide_related');
              if (relatedContent) relatedContent.classList.remove('show_related');
              setSectionHeight();
            }
          })
          .catch((error) => {
            console.error('Error updating recommendations:', error);
            if (dropdown_cart) dropdown_cart.classList.add('hide_related');
            if (relatedContent) relatedContent.classList.remove('show_related');
          });
      }
    };

    if (recommendationsElement) {
      updateRecommendations(recommendationsElement, "product-recommendations-desk");
    }
    if (recommendationsElementMobile) {
      updateRecommendations(recommendationsElementMobile, "product-recommendations-mob");
    }
  },
  removeDrawerClass: function () {
    document.body.classList.remove("cart-drawer-open");
    setSectionHeight();
  },
  addDrawerClass: function () {
    document.body.classList.add("cart-drawer-open");
    setSectionHeight();
    console.log("123456")
  },
  closeDrawerEvent: function () {
    var $this = this;
    document.querySelector(".cartDrawer-close--btn").addEventListener("click", function () {
      $this.removeDrawerClass();
    });
    document.querySelector(".drawer-overlay").addEventListener("click", function () {
      $this.removeDrawerClass();
    });
  },
  removeItemFromCart: function () {
    var $this = this;
    document.querySelectorAll(".item--btn-remove").forEach(function (evt) {
      evt.addEventListener("click", function () {
        var variantId = this.dataset.variantid,
          quantity = this.dataset.quentity;
        var item = {
          id: variantId,
          quantity: 0
        }
        $this.changeQuantity(item)
      });
    })
  },
  changeQuantity: function (item) {
    var $this = this;
    // document.querySelector('[loading-for-ajaxdrawer]').style.display = 'block';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    }).then((res) => { return res.json() })
      .then((response) => {
        // Check if cart is now empty after removing item
        if (response.item_count === 0) {
          // Update cart count in DOM immediately
          document.querySelector(".cartBubbleCount").innerText = "0";
        }

        $this.getCartData();
      })
      .catch((error) => {
        console.error('Error:', error);
        return false;
      });
  }

}

